import { Component, h, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-search-bar-button",
    styleUrl: "search-bar.scss",
})
export class SearchBarButton {
    /** label for search button. If string is empty, only the icon will be shown */
    @Prop() label: string = "";

    render() {
        if (this.label === "") {
            return (
                <ux-button
                    type="submit"
                    variant="primary"
                    size="icon"
                    icon="search"
                ></ux-button>
            );
        } else {
            return (
                <ux-button type="submit" variant="primary">
                    <span>{this.label}</span>
                    <ux-icon name="search"></ux-icon>
                </ux-button>
            );
        }
    }
}
